// Estilos globais da barra de rolagem, aplicados via <GlobalStyles /> no App.
// Recebe o flag darkMode do controller para combinar com o tema atual.

interface ScrollbarColors {
    thumb: string;
    thumbHover: string;
}

const LIGHT: ScrollbarColors = {
    thumb: '#c1c9d2',
    thumbHover: '#a3aeb9',
};

const DARK: ScrollbarColors = {
    thumb: '#334155',
    thumbHover: '#475569',
};

const SIZE = 14;

export function scrollbarStyles(darkMode: boolean) {
    const { thumb, thumbHover } = darkMode ? DARK : LIGHT;

    // Obs: NÃO usamos as props padrão scrollbar-width/scrollbar-color aqui.
    // No Chromium 121+ elas desativam o estilo ::-webkit-scrollbar, o que
    // apagaria a customização abaixo. Este app roda em Chromium/Electron.
    return {
        // Chromium / WebKit (Chrome, Edge, Electron, etc.)
        '*::-webkit-scrollbar': {
            width: SIZE,
            height: SIZE,
        },
        '*::-webkit-scrollbar-track': {
            background: 'transparent',
        },
        '*::-webkit-scrollbar-thumb': {
            backgroundColor: thumb,
            borderRadius: SIZE,
            // borda transparente cria um respiro entre o thumb e a borda do track
            border: '2px solid transparent',
            backgroundClip: 'padding-box',
        },
        '*::-webkit-scrollbar-thumb:hover': {
            backgroundColor: thumbHover,
        },
        '*::-webkit-scrollbar-corner': {
            background: 'transparent',
        },
    };
}
